const RPA_ROUTE = [
  {
    path: 'rpa/task-list',
    name: 'RpaTaskList',
    component: () => import('@/views/rpa/index.vue'),
    meta: {
      title: 'RPA任务列表',
      icon: '',
      keepAlive: true,
    },
  },
]
export default RPA_ROUTE
